document.addEventListener('DOMContentLoaded',function(){var d=document.querySelector('.product__description');if(d&&d.scrollHeight>d.clientHeight+10){var b=document.createElement('button');b.className='khan-desc-toggle';b.textContent='Read more';b.onclick=function(){d.classList.toggle('expanded');b.textContent=d.classList.contains('expanded')?'Read less':'Read more';};d.parentNode.insertBefore(b,d.nextSibling);}});
// Size modal tabs
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('khan-tab')) {
    var modal = e.target.closest('.khan-size-modal');
    modal.querySelectorAll('.khan-tab').forEach(function(t) { t.classList.remove('active'); });
    modal.querySelectorAll('.khan-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    e.target.classList.add('active');
    modal.querySelector('[data-panel="' + e.target.dataset.tab + '"]').classList.add('active');
  }
});
// Close modal on backdrop click
document.addEventListener('click', function(e) {
  var modal = document.getElementById('khanSizeModal');
  if (modal && e.target === modal) modal.close();
});
